<template>
  <div class="container">
    <slot></slot>
  </div>
</template>
  
<script>
  
export default {
    name: 'LayoutDiv',
};
</script>
<style>
@media (max-width: 768px) {
  .container {
    min-width: 100%;
    background-color: #121738;
    margin: 0;
  }
}
</style>